import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ContactComponent } from './contact/contact.component';
import { FormationComponent } from './formation/formation.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { BeneficiariesComponent } from './beneficiaries/beneficiaries.component';
import { HomeComponent } from './home/home.component';
import { ProgramItemComponent } from './program-item/program-item.component';
import { IconItemComponent } from './icon-item/icon-item.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { TopicsComponent } from './topics/topics.component';
import { WaveComponent } from './wave/wave.component';
import { DocumentsComponent } from './documents/documents.component';
import { HeaderInterceptor } from './services/http-interceptor';
import { BackButtonComponent } from './shared-components/back-button/back-button.component';
import { NoContentComponent } from './shared-components/no-content/no-content.component';
import { CampaignComponent } from './campaign/campaign.component';
import { NewsComponent } from './news/news.component';
import { NewsDetailComponent } from './news-detail/news-detail.component';
import { CampaignDetailComponent } from './campaign-detail/campaign-detail.component';
import { VideosComponent } from './videos/videos.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    ContactComponent,
    FormationComponent,
    AboutUsComponent,
    BeneficiariesComponent,
    HomeComponent,
    ProgramItemComponent,
    IconItemComponent,
    SpinnerComponent,
    TopicsComponent,
    WaveComponent,
    DocumentsComponent,
    BackButtonComponent,
    NoContentComponent,
    CampaignComponent,
    NewsComponent,
    NewsDetailComponent,
    CampaignDetailComponent,
    VideosComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FontAwesomeModule,
    HttpClientModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
